document.addEventListener("DOMContentLoaded", function () {
  // ==============================
  // Splide スライダー初期化
  // ==============================
  const sliders = document.querySelectorAll(".splide");

  sliders.forEach(function (slider, index) {
    if (!slider.id) {
      slider.id = "splide-slider-" + index;
    }

    const autoplay = slider.dataset.autoplay !== "false";
    const interval = parseInt(slider.dataset.interval) || 5000;
    const arrows = slider.dataset.arrows === "true";
    const pagination = slider.dataset.pagination !== "false";
    const perPage = parseInt(slider.dataset.perPage) || 1;
    const gap = slider.dataset.gap || "1rem";

    new Splide("#" + slider.id, {
      type: "loop",
      autoplay: autoplay,
      interval: interval,
      pauseOnHover: true,
      arrows: arrows,
      pagination: pagination,
      perPage: perPage,
      perMove: 1,
      gap: gap,
      breakpoints: {
        749: {
          perPage: 1,
          gap: "0.5rem",
        },
      },
    }).mount();
  });

  // ==============================
  // 内部リンククリック時のスクロール補正
  // ==============================
  const header = document.querySelector("header"); // ← 固定ヘッダーを指定
  const headerHeight = header ? header.offsetHeight : 0;

  // ページ内リンク（#から始まるhref）
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");

      // 空の "#" だけのリンクは無視
      if (targetId === "#") return;

      const target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();

      // ヘッダー高さを引いてスクロール位置を調整
      const targetPosition =
        target.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    });
  });
});